import { FC } from 'react';
import { orderBy } from 'natural-orderby';
import SimpleSelect from '../../select/SimpleSelect';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { getNames } from 'src/common/utils/others';

interface IProps {
  check: boolean;
  className?: string;
  setLocation: (start: string, end: string | undefined) => void;
}

const Location: FC<IProps> = ({ check, className, setLocation }) => {
  const {
    van: {
      filters: { location, sub_location, end_location }
    },
    location: { locationList }
  } = useTypedSelector(state => state);

  const sortedLocation = orderBy(
    locationList,
    [location => location.country, location => location.name],
    ['asc', 'asc']
  );
  return (
    <div className={`filter__location ${className}`}>
      <SimpleSelect
        data={sub_location ? sub_location : location}
        setData={e => setLocation(e, end_location)}
        dataArrey={getNames(sortedLocation)}
        placeholder='Where?'
        style={{ width: `190px` }}
        notShowSelect
        title='Start in'
        check={check}
      />
    </div>
  );
};
export default Location;
